<template>
  <b-modal
    :id="id"
    title="Ajustar saldo"
    ok-title="Aplicar"
    cancel-title="Cancelar"
    @ok="submit"
  >
    <b-form @submit.prevent="submit">
      <b-form-group description="Usa valores positivos o negativos.">
        <template #label>
          Delta
        </template>
        <b-input-group prepend="$">
          <b-form-input
            v-model.number="delta"
            type="number"
            step="0.01"
            required
          />
        </b-input-group>
      </b-form-group>

      <b-form-group label="Nota (opcional)">
        <b-form-input v-model="note" />
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
export default {
  name: 'WalletAdjustModal',
  props: { id: { type: String, default: 'wallet-adjust-modal' } },
  data() { return { delta: null, note: '' } },
  methods: {
    submit() {
      if (!this.delta || Number.isNaN(this.delta)) return
      this.$emit('confirm', { delta: this.delta, note: this.note })
      this.delta = null; this.note = ''
    },
  },
}
</script>
